import {
  faCog,
  faKeyboard,
  faList,
  faMinusCircle,
  faPlus,
  faPlusCircle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import {
  Modal as AntModal,
  Button,
  Dropdown as AntDropdown,
  Input,
  Spin,
  Select,
  message 
} from "antd";
import { Col, Row } from "reactstrap";
import swal from "sweetalert";
import JoditTextEditor from "../../common/JoditEditor/JoditTextEditor";
import { RoleUserPicker } from "../../../src/components/Roles/RoleUserPicker";
import AwsServerService from "../../common/util/AwsServerService"; 
import { PlusOutlined } from "@ant-design/icons";
import { GlobalAgGridTable } from "../Deal/AgGridReactComponent/GlobalAgGridTable";
import HierarchicalDropdown from "../Roles/HierarchicalDropdown";
import { AppDataRequired } from "../../App";
import AppContext from "../../Context/AppContext";
import { useSelector } from "react-redux";
import HashTagInput from "../NamingConvention/HashTagInput";
import { canAccess } from "../../common/util/appUtils";

export default function EmailTemplates({flowId, editTemplate, selectedEdgeData, editFlow, isBlueprintLocked}) {
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [popupOpen, setPopupOpen] = useState(false); 
  const [emailContent, setEmailContent] = useState("");
  const userInfo = JSON.parse(localStorage.getItem('userinfo'));
  const AppData = useContext(AppContext);
  const { dispatch, state } = AppData || {};
  const [AllClients, setAllClients] = useState(state.AllAccounts);
  const { AllUsers } = useContext(AppDataRequired);
  const [templateType, setTemplateType] = useState("Create");
   const [projectRoleObject, setprojectRoleObject] = useState({
          "RoleId": "",
          "UserId": "",
          "UserType": "",
      })
  const [composeMailObj, setComposeMailObj] = useState(
    {   
    selectedTemplate:'',
    TemplateName:'',
    AskReceipt: 'yes',
    // FromAddress: [],
    ToAddress: [{ToAddress:'',AttendeeType:''}],
    CcAddress: [{CcAddress:'',AttendeeType:''}],
    BccAddress: [{BccAddress:'',AttendeeType:''}],
    Subject: "",
    Attachments:[]
  })
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emailsData, setEmailsData] = useState([]);
  const [data, setData] = useState([]);
   const [view,setView] = useState();
  //  const [flowId, setFlowId] = useState();
   const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
   const [allCacheRoles,setAllCacheRoles] = useState([])
   const [allCacheUserRoles,setAllCacheUserRoles] = useState([]);
   const appDataContext = useContext(AppDataRequired);
   useEffect(e=>{
           fetUserRoles();
           fetRoles();
   }, []) 
   const [options,setOptions] = useState([]);
       useEffect(e => {
           if (appDataContext.DealFields) {
               let arr = [...appDataContext.DealFields];
              //  arr.unshift({id:"__1",field:"Actual_Name",name:"Actual Name Of File"})
               setOptions(arr)
           }
     }, [appDataContext.DealFields])
    const TaskFields = [{
        field: "Task_Name",
        id: 0,
        name: "Task Name",
        type: "text"
        },
        {
        field: "Assignee",
        id: 1,
        name: "Assignee",
        type: "text"
        },
        {
        field: "Supervisor",
        id: 2,
        name: "Supervisor",
        type: "text"
        },
    ]
    const fetUserRoles = () => { 
         AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "USERROLES" }).then(res => { 
             setAllCacheUserRoles(res.data);
         }).catch(err => {
             console.log(err);
         })
     }
       const fetRoles = () => {
         AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => { 
             setAllCacheRoles(res.data);
         }).catch(err => {
             console.log(err);
         })
     }
     const getAccountMailIds = (data,type) => {
      if(data && data.length==0){
        return "";
      }
      let emailId=[];
       
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        let value = element[type];
        if(element.AttendeeType == 'Role'){
          let userId=allCacheRoles?.find(e=>e.ROWID==value); 
          emailId.push(`${userId?.RoleName} (${userId?.RoleType})`);
        }else if( element.AttendeeType == "Zoho"){
          let mail = AllUsers?.find(e=>e.zuid == value)?.email;
          emailId.push(mail);
        }else if(element.AttendeeType == "Account"){
          let mailId = Object.values(moduleContacts || {}).flat()?.find(k => k.id == element.ToAddress)?.Email
          emailId.push(mailId);
        }
      }
      return emailId.join(", ");
    }
  useEffect(e=>{
  if(!popupOpen){
    setComposeMailObj({ 
    selectedTemplate:'',
    TemplateName:'',
    AskReceipt: 'yes',
    // FromAddress: [],
    ToAddress: [{ToAddress:'',AttendeeType:''}],
    CcAddress: [{CcAddress:'',AttendeeType:''}],
    BccAddress: [{BccAddress:'',AttendeeType:''}],
    Subject: "",
    Attachments:[]
    })
    setTemplateType('Create');
    setEmailContent("");
    setShowBCC(false);
    setShowCC(false); 
  }
  },[popupOpen]) 
  const getCCOptions = () => {
    const items = [
      {
        label: (
          <a
            onClick={() => {
              setShowCC(!showCC);
              setComposeMailObj({...composeMailObj,CcAddress:[{CcAddress:'',AttendeeType:''}]})
            }}
          >
            {showCC ? "Hide CC" : "Show CC"}
          </a>
        ),
        key: "0",
      },
      {
        label: (
          <a
            onClick={() => {
              setShowBCC(!showBCC);
              setComposeMailObj({...composeMailObj,BccAddress:[{BccAddress:'',AttendeeType:''}]})
            }}
          >
            {showBCC ? "Hide BCC" : "Show BCC"}
          </a>
        ),
        key: "1",
      },
    ];
    return (
      <AntDropdown
        overlayStyle={{ zIndex: "9999" }}
        className="CC-setting-icon"
        menu={{
          items,
        }}
        arrow={{
          pointAtCenter: true,
        }}
        trigger={["click"]}
      >
        <Button variant="outline-primary" onClick={(e) => e.preventDefault()}>
          <FontAwesomeIcon icon={faCog} />
        </Button>
      </AntDropdown>
    );
  };

  const actionListCellRenderer= (params)=> { 
    const canEdit = canAccess(accessContext, "Email Template", "Edit")
    const canDelete = canAccess(accessContext, "Email Template", "Delete")
    // console.log(params);
    let btnDiv=document.createElement("div");
    btnDiv.classList.add("global-action-btn-for-tables");
    
    let editBtn=document.createElement('button');
    editBtn.classList.add("add")
    editBtn.innerText="Edit"
    editBtn.id=params.ROWID;
    editBtn.addEventListener('click',(e)=>{
      if(!canEdit){
        message.error("Permission Denied");
        return;
      }
      setTemplateType("Edit"); 
      if(params?.CcAddress?.length>0 && params?.CcAddress[0]?.CcAddress!=''){
        setShowCC(true);
      }else{
        setShowCC(false);
      }
      if(params?.BccAddress?.length>0 && params?.BccAddress[0]?.BccAddress!=''){
        setShowBCC(true);
      }else{
        setShowBCC(false);
      }
      let Rowid=e.currentTarget.id;
      if(params.ROWID == Rowid){
        setEmailContent(params.EmailContent)
        setComposeMailObj(structuredClone(params))
        // setFlowId(params.TaskFlowId)
        setPopupOpen(true)
      }
    })
    let deleteBtn=document.createElement('button');
    deleteBtn.classList.add("add")
    deleteBtn.style.color="red";
    deleteBtn.innerText="Delete";
    deleteBtn.id=params.ROWID;
    deleteBtn.addEventListener('click',(e)=>{ 
      if(!canDelete){
        message.error("Permission Denied");
        return;
      }
      let Rowid=e.currentTarget.id;
      swal({
        title: "Warning!",
        text: `Are you sure you want to delete the email template?`,
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "Proceed",
        },
      }).then(async(isDelete)=>{
        if(isDelete){
          AwsServerService.deleteFlowEmailTemplate(Rowid).then(res=>{ 
            let temp = [...data];
            temp = temp?.filter((item) => item?.ROWID != Rowid);
            setData(temp);
          }).catch(er=>setLoader(false)).finally(e=>setLoader(false));
        }
      })})
    btnDiv.appendChild(editBtn);
    btnDiv.appendChild(deleteBtn);
    return btnDiv;
  }

  const columnForZoho = [
    {
      field: "TemplateName",
      name: "Template Name",
      path: "TemplateName",
    //   key: "Action",
      type:"text",
      label: "Template Name",
      id : 0,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
    },
    {
      field: "ToAddress",
      name: "To Address",
      path: "ToAddress",
      type:"text",
      label: "To Address",
      id : 1,
      isChecked : false,
      isDragOver : false,
      key:"address",
      isSearch : true,
      content: (obj) =>  getAccountMailIds(obj.ToAddress,'ToAddress')
    },
    {
      field: "CcAddress",
      name: "Cc Address",
      path: "CcAddress",
      type:"text",
      label: "Cc Address",
      id : 1,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      key:"cc",
      content: (obj) =>  getAccountMailIds( obj.CcAddress,'CcAddress' )
    },
    {
      field: "BccAddress",
      name: "Bcc Address",
      path: "BccAddress",
      type:"text",
      label: "Bcc Address",
      id : 1,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      key:"bcc",
       content: (obj) =>  getAccountMailIds( obj.BccAddress,'BccAddress' )
    },
    {
      field: "Action",
      key: "Action",
      name: "Action",
      path: "Action",
      type:"text",
      label: "Action",
      id : 2,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      content:  actionListCellRenderer,
    },
  ];

  const extraComponentToRight=(e)=>{
    return (
      <div className="extra-component-request-toRight">
        <div className="job-action-box">
          <Button
            style={canAccess(accessContext, "Email Template", "Create") ? {} : {opacity: 0.2, pointerEvents: "none", cursor: "not-alloweds"}}
            type='primary'
            className="mr-3 request-btns"
            onClick={() => {
              setEmailContent('');
              setTemplateType('Create');
              setPopupOpen(true)}
            }
          >
            Add Template
          </Button>
        </div>
      </div>
    );
  } 
  
  useEffect(()=>{
  if(selectedEdgeData){
    AwsServerService.getTransitionEmailById(flowId,selectedEdgeData?.id).then(res=>{
      let resArray = res?.data;
      let dataArray=[];
      if(resArray && resArray?.length>0){
        resArray.forEach(element=>{
        let obj={}; 
         obj.TemplateName = element.TemplateName;
         obj.EmailContent = element.EmailContent; 
        //  obj.FromAddress = element.FromAddress; 
         obj.ToAddress = element.ToAddress; 
         obj.CcAddress = element.CcAddress;
         obj.BccAddress = element.BccAddress; 
         obj.AskReceipt = element.AskReceipt;
         obj.Subject = element.Subject;
         obj.TransitionEdgeId = element.TransitionEdgeId;
         obj.ROWID = element.ROWID;
         obj.Attachments = element.Attachments?element.Attachments?.map(el=>el.id):[];
         dataArray.push(obj);
         })
        }
      setEmailsData([...dataArray]);
    }) 
  }
  },[selectedEdgeData])
 
  useEffect(()=>{ 
    setLoader(true);
    AwsServerService.getAllEmailTemplates().then(res=>{  
      setData(res?.data);
    }).catch(er=>setLoader(false)).finally(e=>setLoader(false)); 
  },[])
  
  const handleAttachTransition = () =>{ 
    let obj={...composeMailObj}; 
    obj.EmailContent = emailContent;
    obj.ToAddress = JSON.stringify(obj.ToAddress);
    // let cc =obj.CcAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.CcAddress = JSON.stringify(obj.CcAddress);
    // let bcc =obj.BccAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.BccAddress = JSON.stringify(obj.BccAddress); 
    obj.TransitionEdgeId = selectedEdgeData?.id;
    obj.TaskFlowId= flowId;
    let att = editFlow?.InputFields?.filter(el=>composeMailObj.Attachments.includes(el.id));
    obj.Attachments=JSON.stringify(att);
    obj.CREATEDBY = userInfo.email_id;
    delete obj.selectedTemplate 
    setLoader(true);
    AwsServerService.attachEmailToTrasition(obj).then(res=>{  
      let rowid = res.data.insertId || res.insertId;
      setEmailsData([...emailsData,{...composeMailObj,ROWID:rowid,TransitionEdgeId:selectedEdgeData?.id,EmailContent:emailContent}]);
      setPopupOpen(false);
      setEmailContent('');
    }).catch(er=>setLoader(false)).finally(e=>setLoader(false));
  } 
  const handleUpdateAttachedEmail = () =>{ 
    let obj={...composeMailObj}; 
    obj.EmailContent = emailContent;
    obj.MODIFIEDBY = userInfo.email_id; 
    obj.ToAddress = JSON.stringify(obj.ToAddress);
    // let cc =obj.CcAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.CcAddress = JSON.stringify(obj.CcAddress);
    // let bcc =obj.BccAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    let att = editFlow?.InputFields?.filter(el=>composeMailObj.Attachments.includes(el.id));
    obj.Attachments=JSON.stringify(att);
    obj.BccAddress = JSON.stringify(obj.BccAddress); 
    delete obj.selectedTemplate ;
    setLoader(true);
    AwsServerService.updateTransitionEmail(obj).then(res=>{
      let arrayData = [...emailsData]; 
      let filteredData = arrayData?.filter(el=>el.ROWID != composeMailObj?.ROWID);
      filteredData.push({...composeMailObj,EmailContent:emailContent});
      setEmailsData(filteredData);
      setPopupOpen(false);
      setEmailContent('');
    }).catch(er=>setLoader(false)).finally(e=>setLoader(false));
  }
  const handleDeleteAttachedEmail = (ROWID) =>{
   setLoader(true);
   AwsServerService.deleteTransitionEmail(ROWID).then(res=>{ 
    let temp = [...emailsData];
    temp = temp?.filter((item) => item?.ROWID != ROWID);
    setEmailsData(temp);
  }).catch(er=>setLoader(false)).finally(e=>setLoader(false));
  }
   console.log("composemail object",composeMailObj);
   
  const handleUpdateTemplate = () =>{
    let obj={...composeMailObj}; 
    obj.EmailContent = emailContent;
    obj.MODIFIEDBY = userInfo.email_id; 
    obj.ToAddress = JSON.stringify(obj.ToAddress);
    // let cc =obj.CcAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.CcAddress = JSON.stringify(obj.CcAddress);
    // let bcc =obj.BccAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.BccAddress = JSON.stringify(obj.BccAddress); 
    delete obj.selectedTemplate ;
    delete obj.Attachments;
    setLoader(true);
    AwsServerService.updateFlowEmailTemplate(obj).then(res=>{
      let arrayData = [...data]; 
      let filteredData = arrayData?.filter(el=>el.ROWID != composeMailObj?.ROWID);
      filteredData.push({...composeMailObj,EmailContent:emailContent});
      setData(filteredData);
      setPopupOpen(false);
      setEmailContent('');
    }).catch(er=>setLoader(false)).finally(e=>setLoader(false));
  } 
  
const handleSaveTemplate = () => {
  const nameToSave = composeMailObj?.TemplateName?.trim()?.toLowerCase();

  const isDuplicate = data.some(template =>
    template?.TemplateName?.trim()?.toLowerCase() === nameToSave
  );

  if (isDuplicate) {
    message.warning("Template name already exists.");
    return;
  }
  let obj = { ...composeMailObj };
  obj.EmailContent = emailContent;

    // let to =obj.ToAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // }); 
    obj.ToAddress = JSON.stringify(obj.ToAddress);
    // let cc =obj.CcAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.CcAddress = JSON.stringify(obj.CcAddress);
    // let bcc =obj.BccAddress.map(el=>{
    //   delete el.children;
    //   return el;
    // });
    obj.BccAddress = JSON.stringify(obj.BccAddress); 
    // obj.TaskFlowId = flowId;
    obj.CREATEDBY = userInfo.email_id;
    delete obj.selectedTemplate ;
    delete obj.Attachments;
    setLoader(true);
    AwsServerService.createFlowEmailTemplate(obj).then(res=>{  
      let rowid=res.data.insertId || res.insertId;
      setData([...data,{...composeMailObj,ROWID:rowid,EmailContent:emailContent}]);
      setPopupOpen(false);
      setEmailContent('');
    }).catch(er=>setLoader(false)).finally(e=>setLoader(false));
  }
const validateEmailTemplate = () => {
  if (!composeMailObj.TemplateName?.trim()) {
    message.error("Please enter a template name.");
    return false;
  }

  if (!composeMailObj.Subject?.trim()) {
    message.error("Please enter a subject.");
    return false;
  }

  if (!emailContent?.trim()) {
    message.error("Please enter email body.");
    return false;
  }


  if (!composeMailObj?.ToAddress?.length || !composeMailObj.ToAddress.some(to => to.AttendeeType && to.ToAddress)) {
    message.error("Please add at least one valid recipient in 'To'.");
    return false;
  }


  if (showCC) {
    if (!composeMailObj?.CcAddress?.length || !composeMailObj.CcAddress.some(cc => cc.AttendeeType && cc.CcAddress)) {
      message.error("Please add at least one valid recipient in 'CC'.");
      return false;
    }
  }

  // Validate BCC if shown
  if (showBCC) {
    if (!composeMailObj?.BccAddress?.length || !composeMailObj.BccAddress.some(bcc => bcc.AttendeeType && bcc.BccAddress)) {
      message.error("Please add at least one valid recipient in 'BCC'.");
      return false;
    }
  }

  return true;
};

  const onChnageRoleUserType=({value,index,name,field})=>{ 
    // let d = {...composeMailObj}
    let d = structuredClone(composeMailObj);
    d[field] = d[field]?.map((data,i)=>{
        if(i==index){
                data[name] = value;
                if(name=="AttendeeType"){
                  data[field]=''
                }
                
        }
        return data;
    })
    setComposeMailObj(d);
} 
console.log("Grid Columns", columnForZoho);
console.log("Grid Data Sample", data[0]);

console.log("composeMailObj",composeMailObj);                 
  const emailTemplatePopup = () => {
    return (
      <AntModal
        title={`${templateType} Email Template`}
        open={popupOpen}
        onOk={() => {}}
        onCancel={() =>setPopupOpen(false)}
        destroyOnClose={true}
        wrapClassName="Email-Template-Modal"
        footer={[
          <Button onClick={(e) => setPopupOpen(false)} name="Cancel">
            Cancel
          </Button>,
          <Button onClick={(e) => {
              if (!validateEmailTemplate()) return;
            if(editTemplate){
              if(templateType=='Attach'){
                handleAttachTransition();
              }else{
                handleUpdateAttachedEmail();
              }
            }else if(templateType=='Create'){
              handleSaveTemplate();
            }else{
              handleUpdateTemplate();
            }
            }} name="Save">
            {templateType=='Attach'?"Save":templateType=='Create'?`Save`:`Update`}
          </Button>,
        ]}
      >
        <div>
          {editTemplate && <Row className="pl-0 pr-0 mr-0 ml-0" style={{marginBottom: '1.4em',marginTop: '-1.8rem'}}> 
                <div className="Global-Text-Color email-temp-field">Select </div> 
                <Col sm={12}>
                   <Select 
                       disabled={templateType=='Edit'}
                       className='Global-Text-Color-Temp'
                       showSearch
                       placeholder="Select Email Template" 
                       onDropdownVisibleChange={()=>{}} 
                       value={composeMailObj?.selectedTemplate}
                       onSelect={(value, option) => { 
                         let dataArray=[...data];
                          let obj=dataArray?.filter(element=>element.ROWID == value)[0];
                          if(obj){
                           if(obj?.CcAddress?.length>0 && obj?.CcAddress[0]?.CcAddress!='' ){
                             setShowCC(true);
                            }else{
                             setShowCC(false);
                           }
                           if(obj?.BccAddress?.length>0 && obj?.BccAddress[0]?.BccAddress!=''){
                             setShowBCC(true);
                            }else{
                              setShowBCC(false);
                            }
                           obj.selectedTemplate=obj.TemplateName;
                           setEmailContent(obj?.EmailContent?.replaceAll('"','')); 
                           obj.Attachments = []; 
                           setComposeMailObj(structuredClone(obj));
                           }else{
                           setComposeMailObj({});
                           }
                       }}
                   > 
                       {data?.map(el=><Select.Option value={el?.ROWID}>{el?.TemplateName}</Select.Option>)}
                   </Select>
               </Col>
           </Row> 
          } 
          <Row className="mt-3 pl-0 pr-0 mr-0 ml-0" style={{display: 'flex',flexDirection: 'row',flexWrap: 'nowrap'}}>
          <div className="Global-Text-Color email-temp-field" style={{top:'-1.2em',height: 'fit-content'}}>Name </div>
            <Col sm={11} style={{left: '-2.4rem'}}>
              <Input style={{position:'relative'}} value={composeMailObj.TemplateName} onChange={e=>setComposeMailObj({...composeMailObj,TemplateName:e.currentTarget.value.trimStart()})}/>
            </Col> 
            <Col sm={1} style={{left: '-3.4em'}}>
              <div>{getCCOptions()}</div>
            </Col>
          </Row>  
          <Row className="pl-0 pr-0 mr-3 ml-3">
          <div className="Global-Text-Color email-temp-field" style={{left:0}}>To </div>
          <Col sm={12} style={{border: '1px solid #cdcdcd',paddingTop: '1em',borderRadius: '6px',paddingBottom: '1em'}}>
          {composeMailObj?.ToAddress && composeMailObj?.ToAddress.map((r, i) => {
                 return <Row className="Input-Group pl-0 pr-0 mr-0 ml-0">
                     <Col sm={3}>
                         <span className="labeltext" style={{position: 'relative',top: '.5em',zIndex: 1,background: 'white'}}>
                             Assignee Type <span style={{ color: "red" }}>*</span>
                         </span>
                         <Select
                             placeholder={"Select User Type"}
                             style={{ width: "100%", height: "auto" }}
                             value={composeMailObj?.ToAddress[i].AttendeeType}
                             onChange={(value, option) => { 
                                 onChnageRoleUserType({ value: value, name: "AttendeeType", index: i ,field:'ToAddress'})
                             }}
                         // mode='multiple'
                         > 
                             <Select.Option value={"Role"} >Role</Select.Option>
                             <Select.Option value={"Account"} >Account</Select.Option>
                             <Select.Option value={"Vendor"} >Vendor</Select.Option>
                             <Select.Option value={"Zoho"} >Internal</Select.Option>
                         </Select>
                     </Col>
                     <Col className="d" sm={7}>
                         <span className="labeltext" style={{position: 'relative',top: '.5em',zIndex: 1,background: 'white'}}>
                             {`Select ${composeMailObj.ToAddress[i].AttendeeType?composeMailObj.ToAddress[i].AttendeeType=='Zoho'?'Internal':composeMailObj.ToAddress[i].AttendeeType:"Roles"}`} <span style={{ color: "red" }}>*</span>
                         </span> 
                         <HierarchicalDropdown
                             styles={{width:'100%',height:'auto'}}
                             disabledCondition={!composeMailObj.ToAddress[i].AttendeeType}
                             key={"rolepicker"+i}
                             GroupName={["Account","Zoho","Vendor","Role"].filter(t=>t==composeMailObj.ToAddress[i].AttendeeType)}
                             handleChangeUser={(value, option) => { 
                                 onChnageRoleUserType({value:value,name:"ToAddress",index:i,field:'ToAddress'})
                             }}
                             selectedUsers={composeMailObj?.ToAddress[i].ToAddress}
                         />
                     </Col>
                     
                     <Col className='d-flex align-items-center p0m0' style={{top: '.7em'}} sm={2}>
                         {i==0 &&
                         <FontAwesomeIcon
                             className='mr-2'  
                             onClick={e => {
                                 if (composeMailObj.ToAddress[i].AttendeeType && composeMailObj.ToAddress[i].ToAddress) {
                                     setComposeMailObj(prev => {
                                         let d = { ...prev }
                                         d.ToAddress.unshift({
                                             ToAddress: "",
                                             AttendeeType: "",
                                         })
                                         return d;
                                     })
                                 }
                             }}
                             color={composeMailObj.ToAddress[i].AttendeeType && composeMailObj.ToAddress[i].ToAddress? 'green':"gray"} icon={faPlusCircle} />
                         }
                         <FontAwesomeIcon 
                             onClick={e => {
                                 setComposeMailObj(prev => {
                                     let d = { ...prev }
                                     if(d.ToAddress.length!=1){
                                         d.ToAddress = d.ToAddress.filter((d, k) => k != i);
                                     } else{
                                         d.ToAddress = [{
                                             ToAddress:"",
                                             AttendeeType:"",
                                         }]
                                     }
                                     return d;
                                 })
                             }}
                             color='red' icon={faMinusCircle} />
                     </Col>
                 </Row>
             })}
             </Col> 
          </Row> 
          {showCC && <Row className="pl-0 pr-0 mr-3 ml-3">
          <div className="Global-Text-Color email-temp-field" style={{left:0}}>CC </div>
          <Col sm={12} style={{border: '1px solid #cdcdcd',paddingTop: '1em',borderRadius: '6px',paddingBottom: '1em'}}>
          {composeMailObj?.CcAddress && composeMailObj?.CcAddress.map((r, i) => {
                 return <Row className="Input-Group pl-0 pr-0 mr-0 ml-0">
                     <Col sm={3}>
                         <span className="labeltext" style={{position: 'relative',top: '.5em',zIndex: 1,background: 'white'}}>
                             Assignee Type <span style={{ color: "red" }}>*</span>
                         </span>
                         <Select
                             placeholder={"Select User Type"}
                             style={{ width: "100%", height: "auto" }}
                             value={composeMailObj?.CcAddress[i].AttendeeType}
                             onChange={(value, option) => { 
                                 onChnageRoleUserType({ value: value, name: "AttendeeType", index: i ,field:'CcAddress'})
                             }} 
                         > 
                             <Select.Option value={"Role"} >Role</Select.Option>
                             <Select.Option value={"Account"} >Account</Select.Option>
                             <Select.Option value={"Vendor"} >Vendor</Select.Option>
                             <Select.Option value={"Zoho"} >Internal</Select.Option>
                         </Select>
                     </Col>
                     <Col sm={7}>
                         <span className="labeltext" style={{position: 'relative',top: '.5em',zIndex: 1,background: 'white'}}>
                             {`Select ${composeMailObj.CcAddress[i].AttendeeType?composeMailObj.CcAddress[i].AttendeeType=='Zoho'?'Internal':composeMailObj.CcAddress[i].AttendeeType:"Roles"}`} <span style={{ color: "red" }}>*</span>
                         </span> 
                         <HierarchicalDropdown
                             styles={{width:'100%',height:'auto'}}
                             disabledCondition={!composeMailObj.CcAddress[i].AttendeeType}
                             key={"rolepicker"+i}
                             GroupName={["Account","Zoho","Vendor","Role"].filter(t=>t==composeMailObj.CcAddress[i].AttendeeType)}
                             handleChangeUser={(value, option) => {
                                  
                                 onChnageRoleUserType({value:value,name:"CcAddress",index:i,field:'CcAddress'})
                             }}
                             selectedUsers={composeMailObj?.CcAddress[i].CcAddress}
                         />
                     </Col>
                     
                     <Col className='d-flex align-items-center p0m0' style={{top: '.7em'}} sm={2}>
                         {i==0 &&
                         <FontAwesomeIcon
                             className='mr-2'
                             onClick={e => {
                                 if (composeMailObj.CcAddress[i].AttendeeType && composeMailObj.CcAddress[i].CcAddress) {
                                     setComposeMailObj(prev => {
                                         let d = { ...prev }
                                         d.CcAddress.unshift({
                                             CcAddress: "",
                                             AttendeeType: "",
                                         })
                                         return d;
                                     })
                                 }
                             }}
                             color={composeMailObj.CcAddress[i].AttendeeType && composeMailObj.CcAddress[i].CcAddress? 'green':"gray"} icon={faPlusCircle} />
                         }
                         <FontAwesomeIcon 
                             onClick={e => {
                                 setComposeMailObj(prev => {
                                     let d = { ...prev }
                                     if(d.CcAddress.length!=1){
                                         d.CcAddress = d.CcAddress.filter((d, k) => k != i);
                                     } else{
                                         d.CcAddress = [{
                                             CcAddress:"",
                                             AttendeeType:"",
                                         }]
                                     }
                                     return d;
                                 })
                             }}
                             color='red' icon={faMinusCircle} />
                     </Col>
                 </Row>
             })}
             </Col> 
          </Row>}
          {showBCC && <Row className="pl-0 pr-0 mr-3 ml-3">
             <div className="Global-Text-Color email-temp-field" style={{left:0}}>BCC </div>
             <Col sm={12} style={{border: '1px solid #cdcdcd',paddingTop: '1em',borderRadius: '6px',paddingBottom: '1em'}}>
             {composeMailObj?.BccAddress && composeMailObj?.BccAddress.map((r, i) => {
                    return <Row className="Input-Group pl-0 pr-0 mr-0 ml-0">
                        <Col sm={3}>
                            <span className="labeltext" style={{position: 'relative',top: '.5em',zIndex: 1,background: 'white'}}>
                                Assignee Type <span style={{ color: "red" }}>*</span>
                            </span>
                            <Select
                                placeholder={"Select User Type"}
                                style={{ width: "100%", height: "auto" }}
                                value={composeMailObj?.BccAddress[i].AttendeeType}
                                onChange={(value, option) => { 
                                    onChnageRoleUserType({ value: value, name: "AttendeeType", index: i ,field:'BccAddress'})
                                }}
                            // mode='multiple'
                            > 
                                <Select.Option value={"Role"} >Role</Select.Option>
                                <Select.Option value={"Account"} >Account</Select.Option>
                                <Select.Option value={"Vendor"} >Vendor</Select.Option>
                                <Select.Option value={"Zoho"} >Internal</Select.Option>
                            </Select>
                        </Col>
                        <Col sm={7}>
                            <span className="labeltext" style={{position: 'relative',top: '.5em',zIndex: 1,background: 'white'}}>
                                {`Select ${composeMailObj.BccAddress[i].AttendeeType?composeMailObj.BccAddress[i].AttendeeType=='Zoho'?'Internal':composeMailObj.BccAddress[i].AttendeeType:"Roles"}`} <span style={{ color: "red" }}>*</span>
                            </span> 
                            <HierarchicalDropdown
                                styles={{width:'100%',height:'auto'}}
                                disabledCondition={!composeMailObj.BccAddress[i].AttendeeType}
                                key={"rolepicker"+i}
                                GroupName={["Account","Zoho","Vendor","Role"].filter(t=>t==composeMailObj.BccAddress[i].AttendeeType)}
                                handleChangeUser={(value, option) => {
                                     
                                    onChnageRoleUserType({value:value,name:"BccAddress",index:i,field:'BccAddress'})
                                }}
                                selectedUsers={composeMailObj?.BccAddress[i].BccAddress}
                            />
                        </Col>
                        
                        <Col className='d-flex align-items-center p0m0' style={{top: '.7em'}}  sm={2}>
                            {i==0 &&
                            <FontAwesomeIcon
                                className='mr-2'
                                onClick={e => {
                                    if (composeMailObj.BccAddress[i].AttendeeType && composeMailObj.BccAddress[i].BccAddress) {
                                        setComposeMailObj(prev => {
                                            let d = { ...prev }
                                            d.BccAddress.unshift({
                                                BccAddress: "",
                                                AttendeeType: "",
                                            })
                                            return d;
                                        })
                                    }
                                }}
                                color={composeMailObj.BccAddress[i].AttendeeType && composeMailObj.BccAddress[i].BccAddress? 'green':"gray"} icon={faPlusCircle} />
                            }
                            <FontAwesomeIcon 
                                onClick={e => {
                                    setComposeMailObj(prev => {
                                        let d = { ...prev }
                                        if(d.BccAddress.length!=1){
                                            d.BccAddress = d.BccAddress.filter((d, k) => k != i);
                                        } else{
                                            d.BccAddress = [{
                                                BccAddress:"",
                                                AttendeeType:"",
                                            }]
                                        }
                                        return d;
                                    })
                                }}
                                color='red' icon={faMinusCircle} />
                        </Col>
                    </Row>
                })}
                </Col> 
             </Row> }
          <Row className="pl-0 pr-0 mr-0 ml-0" >
          <div className='Global-Text-Color email-temp-field'>Subject </div>
                <Col sm={12}>
                <HashTagInput
                    value={composeMailObj?.Subject}
                    setValue={val=>{
                        setComposeMailObj({...composeMailObj,Subject:val})
                    }}
                    options={options}
                    taskFields={TaskFields}
                    triggerChar={"{"}
                />
                {/* <Input value={composeMailObj.Subject} onChange={(e) => { 
                  setComposeMailObj({...composeMailObj,Subject:e.currentTarget.value})}} /> */}
                </Col>
          </Row> 
          {editTemplate &&<Row className="pl-0 pr-0 mr-0 ml-0" >
          <div className='Global-Text-Color email-temp-field'>Attachments </div>
          <Col sm={12}>
          <Select 
                      //  disabled={templateType=='Edit'}
                       mode="multiple"
                       className='Global-Text-Color-Temp'
                       showSearch
                       placeholder="Select Email Template" 
                       onDropdownVisibleChange={()=>{}} 
                       value={composeMailObj?.Attachments}
                       onSelect={(value, option) => {   
                        let ids=[...composeMailObj.Attachments]; 
                        ids.push(value); 
                        setComposeMailObj({...composeMailObj,Attachments:ids});
                       }}
                       onDeselect={(value) => { 
                        setComposeMailObj({
                            ...composeMailObj,
                            Attachments: composeMailObj.Attachments.filter(id => id !== value)
                        });
                    }}
                   > 
                       {editFlow?.InputFields?.filter(e=>e.Type=="ATTACHMENT").map(el=><Select.Option value={el?.id}>{el?.Name}</Select.Option>)}
                   </Select>
          </Col>
          </Row>}
          <Row className="pl-0 pr-0 mr-0 ml-0" style={{marginTop:'1.5em'}}>
            <JoditTextEditor
              id="TransitionEmail"
              signature={"NoSignature"}
              //   isSchedule={isSchedule}
              //   Attachments={attachments}
              // emailContent={emailContent}
              commentContent={emailContent}
                // preValues={emailContent}
              //   setIsSchedule= {setIsSchedule}
              //   composeMailObj={composeMailObj}
              //   isDraftAlready={isDraftAlready}
              //   contentShowFlag={contentShowFlag}
              setEmailContent={setEmailContent}
              //   handleUploadFiles={handleUploadFiles}
              //   composeMailToShow={composeMailToShow}
              //   openSchedulePopup={openSchedulePopup}
              //   openAttachmentPopUp={openAttachmentPopUp}
              //   setOpenSchedulePopup={setOpenSchedulePopup}
              //   setOpenAttachmentPopUp={setOpenAttachmentPopUp}
              // onChange={(data) => {
              //   setEditorValue(data);
              // }}
            />
          </Row>
        </div>
      </AntModal>
    );
  };  
  return (
    <div className="Email-Template-Wrapper">
        {emailTemplatePopup()}
        {editTemplate? 
         <div style={{width: '35em',overflow: 'scroll',height: '19vh'}}>
         <div
        className="Card Add-Icon"
        style={
        isBlueprintLocked ? {
            height: "2rem", display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none", opacity: 0.5, cursor: "not-allowed",
          } : {height: "2rem", display: "flex", alignItems: "center", justifyContent: "center", }
      }
        onClick={(e) => {
          setEmailContent('');
          setTemplateType('Attach');
          setPopupOpen(true)}}
      >
        <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faPlus} />
        {"Add Email Trigger"}
        </div> 
        {loader && <Spin style={{top:'6px'}}/>}
        <div className="renderEmailTemplates" style={isBlueprintLocked ? {width: '100%',display: 'flex', flexDirection: 'column', gap: '.6em',marginTop: '.5em',pointerEvents: "none", opacity: 0.5, cursor: "not-allowed"} : {width: '100%',display: 'flex', flexDirection: 'column', gap: '.6em',marginTop: '.5em'}}>
        {emailsData.map((el) => {
          return (
            <div className="Card">
              <div
                onClick={(e) => {
                  setTemplateType('Edit');
                  setEmailContent(el?.EmailContent); 
                  el.selectedTemplate=el.TemplateName;
                  setPopupOpen(true);
                  if(el?.CcAddress?.length>0 && el?.CcAddress[0]?.CcAddress!=''){
                    setShowCC(true);
                  }else{
                    setShowCC(false);
                  }
                  if(el?.BccAddress?.length>0 && el?.BccAddress[0]?.BccAddress!=''){
                    setShowBCC(true);
                  }else{
                    setShowBCC(false);
                  }
                  setComposeMailObj({...el});
                }}
              > 
                {el.TemplateName}
              </div>
              <FontAwesomeIcon
                title="Remove"
                className="Close-Icon"
                style={{ "margin-right": "7px" }}
                icon={faTimes}
                onClick={() => handleDeleteAttachedEmail(el?.ROWID)}
              />
            </div>
          );
        })}
      </div>
        </div>:<>
        {/* <div
        className="Card Add-Icon"
        style={{ height: "fit-content" }}
        onClick={(e) => {
          setEmailContent('');
          setTemplateType('Create');
          setPopupOpen(true)}}
      >
        <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faPlus} />
        {"Add"}
      </div> */}
      {/* <div className="renderTemplates">
      {loader && <Spin style={{top:'6px'}}/>}
        {data.map((el) => {
          return (
            <div className="Card">
              <div
                onClick={(e) => {
                  setTemplateType('Edit');
                  setPopupOpen(true);
                  if(el?.CcAddress?.length>0){
                    setShowCC(true);
                  }else{
                    setShowCC(false);
                  }
                  if(el?.BccAddress?.length>0){
                    setShowBCC(true);
                  }else{
                    setShowBCC(false);
                  }
                  setEmailContent(el?.EmailContent?.replaceAll('"','')); 
                  setComposeMailObj({...el});
                }}
              >
                {el.TemplateName}
              </div>
              <FontAwesomeIcon
                title="Remove"
                className="Close-Icon"
                style={{ "margin-right": "7px" }}
                icon={faTimes}
                onClick={() => handleDeleteTemplate(el?.ROWID)}
              />
            </div>
          );
        })}
      </div> */}
       <div id="myGrid" className='ag-theme-alpine Email-Template-Body'>
          <GlobalAgGridTable
            headers={columnForZoho}
            setRowData={setData}
            cacheRowData={data}
            setCacheRowData={setData}
            module="Email Templates"
            mainUrl="deleteFlowEmailTemplate"
            // DropDownFields={["User Name", "Check In", "Check Out"]}
            rowData={data}
            renderExtraComponent={()=><></>}
            renderExtraComponentToRight={extraComponentToRight}
            isTaskFilterHide={true}
          /> 
        </div>
      </>}
    </div>
  );
}
